import React from 'react';
import { phone } from 'phone';
import Modal from '../../common/Modal';
import { Box, IconButton, makeStyles } from '@material-ui/core';
import { CustomIcon, PhoneInput, Text, ThemeButton } from '../../common';
import {
  PaymentFormInput,
  PaymentFormRow,
  PaymentFormRowContent,
  PaymentFormRowLabel
} from '../../payments/index.troy';
import { notEmptyValidator } from '../../../utils/validation';
import { Form, getFormValues, reduxForm } from 'redux-form';
import { connectTo } from '../../../utils';
import { DOMAIN_LANGUAGE } from '../../../constants/browser';
import { onPhoneKeyPress } from '../../../utils/phone';

const useStyles = makeStyles(theme => ({
  modal: {
    width: 309,
    margin: theme.spacing(2),
    padding: `${theme.spacing(8)}px ${theme.spacing(2)}px ${theme.spacing(
      2
    )}px ${theme.spacing(2)}px`,
    borderRadius: theme.shape.borderRadius * 6,
    boxShadow: theme.customShadows.active
  },
  close: {
    position: 'absolute',
    top: 8,
    right: 8,
    padding: 8
  },
  title: {
    textAlign: 'center'
  },
  description: {
    marginTop: theme.spacing(2),
    textAlign: 'center'
  },
  fields: {
    paddingTop: theme.spacing(3)
  },
  submit: {
    marginTop: theme.spacing(3),
    width: '100%'
  },
  phoneField: {
    width: '100%',

    '& ul': {
      top: 'unset !important'
    }
  }
}));

const ReturnGoodsDetailsModalContent = ({
  handleSubmit,
  onSubmit,
  values,
  isOpen,
  onClose,
  invalid
}) => {
  const classes = useStyles();

  return (
    <Modal paperClassName={classes.modal} isOpen={isOpen} onClose={onClose}>
      {onClose && (
        <IconButton
          id="return-goods.modal.close"
          color="default"
          className={classes.close}
          onClick={onClose}
        >
          <CustomIcon icon="dismissIcon" variant="hint" size="small" />
        </IconButton>
      )}
      <Text
        className={classes.title}
        component="h2"
        variant="h3"
        color="secondary"
      >
        Where should we pick up the goods?
      </Text>
      <Text
        className={classes.description}
        component="p"
        variant="body1"
        color="textPrimary"
      >
        Please provide us with the actual address where our partners can pick up
        the rented goods:
      </Text>
      <Box className={classes.fields}>
        <Form
          className={classes.fields}
          onSubmit={handleSubmit(values => onSubmit(values))}
        >
          <PaymentFormRow compact smallMargin>
            <PaymentFormRowLabel compact>Name</PaymentFormRowLabel>
            <PaymentFormRowContent compact>
              <PaymentFormInput
                name="customerName"
                placeholder={'Your name'}
                validator={notEmptyValidator}
                error={notEmptyValidator(values.customerName)}
                errorMessage={'Please provide name'}
              />
            </PaymentFormRowContent>
          </PaymentFormRow>
          <PaymentFormRow compact smallMargin>
            <PaymentFormRowLabel compact>Street</PaymentFormRowLabel>
            <PaymentFormRowContent compact>
              <PaymentFormInput
                name="street"
                placeholder={'Street'}
                validator={notEmptyValidator}
                error={notEmptyValidator(values.street)}
                errorMessage={'Please provide street'}
              />
            </PaymentFormRowContent>
          </PaymentFormRow>
          <PaymentFormRow compact smallMargin>
            <PaymentFormRowLabel compact>ZIP-Code</PaymentFormRowLabel>
            <PaymentFormRowContent compact>
              <PaymentFormInput
                name="postCode"
                placeholder={'ZIP-Code'}
                validator={notEmptyValidator}
                error={notEmptyValidator(values.postCode)}
                errorMessage={'Please provide zip-code'}
              />
            </PaymentFormRowContent>
          </PaymentFormRow>
          <PaymentFormRow compact smallMargin>
            <PaymentFormRowLabel compact>City</PaymentFormRowLabel>
            <PaymentFormRowContent compact>
              <PaymentFormInput
                name="city"
                placeholder={'City'}
                validator={notEmptyValidator}
                error={notEmptyValidator(values.city)}
                errorMessage={'Please provide city'}
              />
            </PaymentFormRowContent>
          </PaymentFormRow>
          <PaymentFormRow compact smallMargin>
            <PaymentFormRowLabel compact>Country</PaymentFormRowLabel>
            <PaymentFormRowContent compact>
              <PaymentFormInput
                name="country"
                placeholder={'Country'}
                validator={notEmptyValidator}
                error={notEmptyValidator(values.country)}
                errorMessage={'Please provide country'}
              />
            </PaymentFormRowContent>
          </PaymentFormRow>
          <PaymentFormRow compact smallMargin>
            <PaymentFormRowLabel compact>Telephone</PaymentFormRowLabel>
            <PaymentFormRowContent compact>
              <PhoneInput
                containerClassName={classes.phoneField}
                name="phone"
                preferredCountries={[DOMAIN_LANGUAGE.toLowerCase()]}
                formatOnInit={false}
                error={!values.phone.isValid}
                errorMessage={'Invalid Phone number'}
                onKeyPress={onPhoneKeyPress}
              />
            </PaymentFormRowContent>
          </PaymentFormRow>
          <ThemeButton
            className={classes.submit}
            id="page.return-goods.details-modal.confirm-button"
            disabled={invalid || !values.phone.isValid}
            type="submit"
            variant="contained"
            size="large"
            endIcon="confirm"
            endIconColor="primaryContrast"
            textKey={'Save'}
          />
        </Form>
      </Box>
    </Modal>
  );
};

const RETURN_GOODS_MODAL_FORM_NAME = 'return-goods-change-details';

const ReturnGoodsDetailsModal = reduxForm({
  form: RETURN_GOODS_MODAL_FORM_NAME,
  enableReinitialize: true
})(
  connectTo(
    state => ({
      values: getFormValues(RETURN_GOODS_MODAL_FORM_NAME)(state)
    }),
    {},
    ReturnGoodsDetailsModalContent
  )
);

export default ReturnGoodsDetailsModal;
